<template>
  <div class="app__product">
    <div :class="{'app__diamond': true, 'app__diamond--top': true, 'app__diamond--white': true}"></div>
    <Close />
    <div class="app__productWrapper" v-if="product">
      <div class="app__productWrapper2">

        <StepLabel :step="step.step_number"/>
        <Steps :max-steps="maxSteps" :active-step="step.step_number" :steps="steps"/>

        <div class="app__productTitle" v-html="step.title"></div>

        <div class="app__productInner">
          <div class="app__productImage">
            <div class="app__productImage img" :style="{backgroundImage: 'url(' + product.image + ')'}"></div>
          </div>

          <div class="app__productText">
            <a :href="product.url" target="_self" class="app__productName">{{product.title}}</a>
            <a :href="product.category.url" target="_self" class="app__productCategory" v-if="product.category">{{product.category.name}}</a>
            <hr class="app__productHr">
            <div class="app__productDesc" v-if="product.description" v-html="product.description"></div>
            <div class="app__productLink" v-if="product.url">
              <a :href="product.url" target="_self" class="btn btn__link btn__rightIcon">zobacz <i class="icon-strzalka"></i></a>
            </div>

            <div class="app__productUpSell" v-if="product.up_sell_is_active">
              <div class="app__productUpSellDesc" v-html="product.up_sell.description"></div>
              <div class="app__productUpSellImage">
                <img :src="product.up_sell.image_path" :alt="product.up_sell.name">
              </div>
            </div>
          </div>
        </div>

        <div class="app__productButton">
          <button class="btn btn__primary" @click="setStart()">{{ step.label_text }} <i class="icon-strzalka"></i></button>
        </div>
      </div>
    </div>
    <div class="app__diamond app__diamond--bottom app__diamond--green2"></div>
  </div>
</template>

<script>
import EventBus from "../../event-bus.js";
import Close from "./../Parts/Close.vue";
import StepLabel from './../Parts/StepLabel.vue';
import Steps from './../Parts/Steps.vue';
import axios from "axios";

export default {
  props: ['settings', 'currentStep', 'step', 'steps', 'maxSteps', 'restUrlProduct', 'path'],
  components: {
    Close,
    StepLabel,
    Steps
  },
  data: () => ({
    active: false,
    product: {}
  }),
  mounted() {
    this.product = this.step.product;
  },
  methods: {
    setStart() {
      EventBus.$emit('SET_START', 0);
    }
  }
}
</script>
